angular
  .module('fca-used')
  .component('accordion', {
    controller: accordionController,
    controllerAs: 'accordion'
  });

function accordionController() {
  var accordion = this;

  accordion.panels = [];

  accordion.addPanel = function (panel) {
    accordion.panels.push(panel);
  };

  accordion.togglePanel = function (panel) {
    if (panel.open) {
      panel.open = !panel.open;
    } else {
      for (var i = accordion.panels.length - 1; i >= 0; i--) {
        accordion.panels[i].open = accordion.panels[i] === panel;
      }
    }
  };
}
